export const isPermissionDeniedError = (error: Error): boolean => (
  error?.message?.toLowerCase().includes('permission denied')
);
